import app from 'flarum/forum/app';

// Mithril global.

/**
 * Section links (forum feed, articles, members, catalogue cards) and links in a
 * designer-built page are plain anchors, so clicking one reloaded the whole
 * forum: every script and stylesheet, where Flarum's own links navigate in
 * place. This sends a click on a link to one of the forum's own pages through
 * the router instead.
 *
 * Only for a plain left click on a same-site link that matches a route the app
 * knows; a new-tab click, a download, an external link or a server-only path
 * (the API, admin, assets) is left to the browser.
 */

let patterns = null;
function routePatterns() {
  if (!patterns) {
    patterns = Object.values(app.routes || {}).map(r => String(r && r.path ? r.path : '')).filter(Boolean).map(p => new RegExp('^' + p.replace(/[.*+?^${}()|[\]\\]/g, '\\$&').replace(/\\?:[A-Za-z_]+/g, '[^/]+') + '/?$'));
  }
  return patterns;
}

/** The in-app route for a link, or null when the browser should handle it. */
export function routeFor(a) {
  if (a.target && a.target !== '_self') return null;
  if (a.hasAttribute('download')) return null;
  let url;
  let base;
  try {
    url = new URL(a.href, window.location.href);
    base = new URL(String(app.forum.attribute('baseUrl') || window.location.origin));
  } catch {
    return null;
  }
  if (url.origin !== base.origin) return null;
  const prefix = base.pathname.replace(/\/$/, '');
  if (prefix && url.pathname !== prefix && !url.pathname.startsWith(prefix + '/')) return null;
  const path = url.pathname.slice(prefix.length) || '/';
  return routePatterns().some(re => re.test(path)) ? path + url.search + url.hash : null;
}
let installed = false;

/** Route clicks on links inside `selector` through Flarum's router. Install once. */
export function installSpaLinks(selector) {
  if (installed) return;
  installed = true;
  document.addEventListener('click', e => {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    const a = e.target?.closest?.('a[href]');
    if (!a || !a.closest(selector)) return;
    const route = routeFor(a);
    if (route === null) return;
    e.preventDefault();
    m.route.set(route);
  });
}
flarum.reg.add('ernestdefoe-page-builder', 'forum/util/spaLinks', { routeFor: routeFor,installSpaLinks: installSpaLinks, });